export const SET_INFO = 'SET_INFO';
